import { List } from "immutable";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import { ResumeDetailsPartial } from "./ResumeDetailsPartial";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { CareerCenterHelper } from "../../../models/careerCenter/CareerCenterHelper";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    isLoggedIn: state.auth.data !== undefined && state.auth.data.hasUserRecord,
    resumes: state.careerCenter.resumes,
    prevPath: state.router.location && state.router.location.state ? state.router.location.state.prevPath : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
});

type OwnProps = RouteComponentProps<{
    slug: string;
    id: string;
}> & {
};

interface ConnectedState {
    api: Api;
    isLoggedIn: boolean;
    resumes: List<M.CareerCenter.Resume>;
    prevPath?: string;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
}

interface OwnState {
    invalidRecord: boolean;
    resume?: M.CareerCenter.Resume;
}

class ResumeDetailsComponent extends Comp.Base.BaseComponent<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            invalidRecord: false,
            loading: true,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const slug = this.props.match.params.slug;
        const id = Utility.getIdFromSlug(slug);
        const slugTitle = this.getSluggedTitle(slug);
        if (!slug || !id) {
            this.props.notifyError("Resume identifier is missing in URL");
            this.setState({ ...this.state, invalidRecord: true });
            return;
        }

        // get resume from state if available
        if (this.props.resumes.size) {
            const resume = this.props.resumes.find((x) => x !== undefined && x.id === id);
            if (resume) {
                this.setState({ ...this.state, resume });
                this.toggleLoading(false);
            }
        }

        const qp = { queryParams: { id } };
        const result = await this.props.api.get<M.CareerCenter.Resume>(Api.endpoints.careerCenter.resume, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (result.data.statusId !== CareerCenterStatuses.Active.id) {
                this.props.notifyError("The requested resume has been removed or is expired.");
                this.setState({ ...this.state, invalidRecord: true });
                return;
            }

            // make sure slug is correct
            const recordSlug = Utility.toSlug(result.data.title);
            if (recordSlug !== slugTitle)
                this.props.goto(CareerCenterHelper.resumeDetailsLink(result.data));

            this.setState({ ...this.state, resume: result.data });
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.props.notifyError(errors.join("<br />"));
            this.setState({ ...this.state, invalidRecord: true });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        if (this.state.invalidRecord)
            return <Comp.Generic.RedirectWithStatus to={Paths.CareerCenter.ResumeDirectory} />;

        const resume = this.state.resume;
        const details = resume
            ? <ResumeDetailsPartial api={this.props.api} resume={resume} isFullPage isLoggedIn={this.props.isLoggedIn} />
            : null;

        const loginNote = this.props.isLoggedIn
            ? null
            : <BS.Alert bsStyle="info">
                <h3>Login required</h3>
                <p><Link to={Paths.Helper.Login(this.props.match.url)}>Please sign in</Link> to view the resume profile.</p>
            </BS.Alert>;

        return <Comp.Page.PublicPage pageTitle={resume && resume.title} style={{ minHeight: "200px", position: "relative" }}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />
            <h1>
                <Link to={Paths.CareerCenter.Landing}>Career Center</Link> &raquo;{" "}
                <Link to={this.props.prevPath || Paths.CareerCenter.ResumeDirectory}>Search CVs/Resumes</Link>
            </h1>

            {loginNote}
            {details}
        </Comp.Page.PublicPage>;
    }

    private getSluggedTitle(slug: string) {
        return slug.replace(/(resume\-)|((\-\d+)$)/g, "");
    }
}

export const ResumeDetails: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(ResumeDetailsComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/careerCenter/resumeDetails/ResumeDetails.tsx